import { render, staticRenderFns } from "./ProcedureSharePayment.vue?vue&type=template&id=5ee1f76f&"
import script from "./ProcedureSharePayment.vue?vue&type=script&lang=ts&"
export * from "./ProcedureSharePayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports